module.exports = __webpack_public_path__ + "static/art2-dcbca819d79ea9051fbff1ace274e60e.png";